import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  CardActions,
  Button,
} from "@mui/material";
import SorteioDetalhesModal from "../SorteioDetalhesModal";

export type SystemType = "MERCADOTERRA" | "ESCALA11";

// Interface para as propriedades de um sorteio, reutilizada do ListaSorteio
interface SorteioProps {
  id: string;
  title: string;
  description: string;
  startDate: string;
  drawDate: string;
  displayEndDate: string;
  minNumber: number;
  maxNumber: number;
  ticketsPerUser: number;
  participationRule: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  tickets: any[];
  participantsCount: number;
  availableNumbers: number;
  totalPrize: number;
  prizePercentage: number;
  prizeInfo: {
    basePrize: number;
    currentPrize: number;
    totalPrizeIncrease: number;
    approvedAdsCount: number;
    totalApprovedAdsValue: number;
    hasDynamicPrize: false;
    hasFixedPrize: boolean;
    hasPercentageOnly: boolean;
  };
  role: "MASTER" | "PARTNER" | "ANALYST"; // Role do usuário]
  system: SystemType;
}

// Interface para as props específicas do CardSorteio
interface CardSorteioProps extends SorteioProps {
  token: string; // Necessário para passar ao modal de detalhes para requisições internas
  onSorteioUpdated: () => void; // Callback para recarregar a lista principal após edição/deleção
}

const CardSorteio: React.FC<CardSorteioProps> = (props) => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  // Desestruturamos apenas as props que serão exibidas diretamente no Card
  const { title, drawDate, startDate, displayEndDate, system } = props;

  // Formatação das datas para exibição
  const formattedDrawDate = new Date(drawDate).toLocaleDateString();
  const formattedStartDate = new Date(startDate).toLocaleDateString();
  const formattedDisplayEndDate = new Date(displayEndDate).toLocaleDateString();

  // Funções para abrir e fechar o modal
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const escala11ButtonStyleActive = {
    mr: 1,
    backgroundColor: "#008870",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#005848ff",
    },
  };

  const escala11ButtonStyleOutline = {
    color: "#008870",
    "&:hover": {
      color: "#005848ff",
    },
  };

  const isEscala11 = system === "ESCALA11";

  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography gutterBottom variant="h5" component="div">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Data do Sorteio: {formattedDrawDate}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Data Inicial: {formattedStartDate}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Data Final: {formattedDisplayEndDate}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Button
          size="small"
          onClick={handleOpenModal}
          sx={isEscala11 ? escala11ButtonStyleOutline : {}}
        >
          Ver Detalhes
        </Button>
      </CardActions>

      {/* Renderiza o modal de detalhes, passando todas as props necessárias */}
      <SorteioDetalhesModal
        open={openModal}
        onClose={handleCloseModal}
        sorteio={props} // Passa todas as propriedades do sorteio
        token={props.token} // Passa o token para as requisições dentro do modal
        onSorteioUpdated={props.onSorteioUpdated} // Passa o callback para recarregar a lista principal
        system={system}
      />
    </Card>
  );
};

export default CardSorteio;
